import { useEffect, useState } from "react";
import { Phone, ShieldCheck, Clock, Banknote } from "lucide-react";
import Seo from "../components/Seo";
import QuoteWizard from "../components/QuoteWizard";
import CallbackForm from "../components/CallbackForm";
import { track } from "../lib/api";

export default function SellYourCar() {
  return (
    <>
      <Seo title="Sell Your Car for Cash | Free Instant Quote | Car To Cash" description="Get a free, no-obligation cash quote for your car in minutes. Any make, model or condition across Melbourne & regional Victoria. Paid on the spot." canonical="https://cartocash.com.au/sell-your-car" />
      <section className="noise-dark text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 lg:py-16 grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <h1 className="font-display text-4xl sm:text-5xl font-black leading-tight">Sell your car for cash</h1>
            <p className="mt-4 text-lg text-white/80">Answer a few quick questions and we'll come back with a fair, no-obligation offer. Most quotes take under two minutes.</p>
            <ul className="mt-8 space-y-4">
              {[[ShieldCheck, "No obligation", "Free quote, 7-day honour period."], [Clock, "~10 minute inspection", "We come to you, or you drop by."], [Banknote, "Paid on the spot", "Cash or EFT the moment you accept."]].map(([Icon, t, d]) => (
                <li key={t} className="flex gap-3"><Icon className="h-6 w-6 text-brand-gold shrink-0" /><div><p className="font-bold">{t}</p><p className="text-sm text-white/70">{d}</p></div></li>
              ))}
            </ul>
            <a href="tel:0431206206" onClick={() => track("phone_tap", { where: "sell" })} className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-gold px-6 py-3.5 font-extrabold text-brand-navy hover:bg-brand-goldDark transition-colors" data-testid="sell-call-btn"><Phone className="h-4 w-4" /> Prefer to talk? 0431 206 206</a>
            <div className="mt-8"><CallbackForm /></div>
          </div>
          <div className="lg:col-span-3"><QuoteWizard /></div>
        </div>
      </section>
    </>
  );
}
